export default __webpack_public_path__ + "static/media/poster17.a1bf8fed.png";